define('../src/sublayouts/m1-header/m1-header',['jquery'], function ($) {

    'use strict';

    var M1_HEADER = function ($component) {

        this.$component = $component;

        return this;
    };

    M1_HEADER.prototype.init = function () {

        var mobileMenuBtn = $('.m1-header--mobile-menu'),
            mobileMenuBar = $('.m1-header--menubar'),
            mobileMenu = $('.m1-header--menu'),
            mobileMenuItem = $('.m1-header--menu .m1-header--menu_item');

            
            $('.fixMenu').find('.icon-cancel').click()

            mobileMenuBar.removeClass('fixMenu')


            mobileMenuBtn.on('click',function(){
                if($(this).hasClass('icon-menu')){
                    mobileMenu.addClass('show')
                    mobileMenuBar.addClass('fixMenu')
                    $(this).addClass('icon-cancel')
                    $(this).removeClass('icon-menu')
                }else{
                    mobileMenu.removeClass('show')
                    mobileMenuBar.removeClass('fixMenu')
                    $(this).removeClass('icon-cancel')
                    $(this).addClass('icon-menu')
                }
                
            })

            $('.mobileMenuItem').on('click',function(){
                if($(window).width() < 1025){
                    mobileMenu.removeClass('show')
                    mobileMenuBar.removeClass('fixMenu')
                    mobileMenuBtn.removeClass('icon-cancel')
                    mobileMenuBtn.addClass('icon-menu')
                }
            })

              $(document).ready(function($){

                $('.grid').css('opacity','1')
              })
            $( window ).scroll(function() {

                
                    if($(document).scrollTop() == 0){
                        $('.m1-header').removeClass('header-fix')
                    }
                    if($(document).scrollTop() > 90){
                        $('.m1-header').addClass('header-fix')
                    }
            })

    }


    return M1_HEADER;

});
